import React, { useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import NewModal from "../NewModal";
import Logo from "../../../images/unitec-en-linea.jpeg";
import pnd from "../../../images/pnd.png";
import { postRequest } from "../../Funciones/requester";
import "./index.css";

export default function Header(props) {
  const [modalSesion, setModalSesion] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  async function logout() {
    setModalLoading(true);
    localStorage.removeItem("token_sica");
    localStorage.removeItem("campus_id");
    await postRequest("/sesion/logout");
    window.location.reload();
  }

  return (
    <header>
      <div className='logo'>
        <img src={Logo} alt='Logo UVM' />
      </div>
      <div className='page-title'>
        <h1>SICA 2.0</h1>
      </div>
      <div className='user-info'>
        <div>
          <p className='user-name'>{props.username}</p>
          <p className='user-rol'>
            {props.rol}({props.campus})
          </p>
        </div>
        {props.image ? (
          <img
            onClick={() => setModalSesion(true)}
            src={props.image}
            alt='profile'
          />
        ) : (
          <img src={pnd} onClick={() => setModalSesion(true)} alt='profile' />
        )}
      </div>
      <NewModal
        title='Cerrar sesión'
        open={modalSesion}
        handleClose={() => setModalSesion(false)}
        handleSubmit={logout}
        height={115}
      >
        <div
          style={{ height: "80px", textAlign: "center", paddingTop: "20px" }}
        >
          {modalLoading ? (
            <CircularProgress />
          ) : (
            <p style={{ textAlign: "center" }}>
              ¿Está seguro de que desea cerrar sesión?
            </p>
          )}
        </div>
      </NewModal>
    </header>
  );
}
